import { PercentageTooltip } from 'pages/NewOverview/components/History/PercentageTooltip';
import { ReactElement } from 'react';
import { colorByThermalComfortVariant, parseThermalComfortVariantLabel } from '../../helpers';
import { ThermalComfortVariant } from '../UnitsInfo/types';

interface ThermalComfortGraphTooltipProps {
  date: string;
  percentage: number;
  units: number;
  variant: ThermalComfortVariant;
  type: 'day' | 'month'
}

export function ThermalComfortGraphTooltip({
  date,
  units,
  percentage,
  type,
  variant,
}: Readonly<ThermalComfortGraphTooltipProps>): ReactElement {
  const color = colorByThermalComfortVariant(variant);

  return (
    <PercentageTooltip
      color={color}
      date={date}
      description={parseThermalComfortVariantLabel(variant)}
      percentage={percentage}
      type={type}
      units={units}
      dataTestId="thermal-comfort-chart-tooltip"
    />
  );
}
